import Event from '../../core/Event';

export default class UserAuthenticationFailed extends Event {
    public static type = 'UserAuthenticationFailed';

    constructor(public readonly message: string) {
        super(UserAuthenticationFailed.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/user/events/UserAuthenticationFailed.ts